const TopicDetailsView = async () => import('@/views/other/TopicDetailsView.vue')
import type { _RouteLocationBase } from 'vue-router'

export default [
  {
    path: '/other/improvements/topic/:id',
    name: 'improvement_topic_details',
    component: TopicDetailsView,
    props: (route: _RouteLocationBase) => {
      return { id: route.params.id as string }
    }
  }
]
